import { render, staticRenderFns } from "./BillingSummary.vue?vue&type=template&id=4ba83998&scoped=true&"
import script from "./BillingSummary.vue?vue&type=script&lang=js&"
export * from "./BillingSummary.vue?vue&type=script&lang=js&"
import style0 from "./BillingSummary.vue?vue&type=style&index=0&id=4ba83998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba83998",
  null
  
)

export default component.exports